class Accordion {
  public trigger: NodeListOf<HTMLElement>;

  bindings() {
    if (this.trigger) {
      this.trigger.forEach((item) => {
        item.addEventListener('click', (e: Event) => {
          (item.parentElement as HTMLElement).classList.toggle('is-active');
        });
      });
    }
  }

  cache() {
    this.trigger = document.querySelectorAll('.o-wishlist-accordion__header-trigger');
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default Accordion;
